import React from 'react';
import { Button } from 'reactstrap';
import ColumnButton from '../ColumnButton';
import HtmlHelpers from '../HtmlHelpers';
import TableFilters from '../TableFilters';
const ColumnHelpers = {};
ColumnHelpers.auditLogLink = function (context) {
  let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  let show = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    id: 'log',
    Cell: row => /*#__PURE__*/React.createElement(Button, {
      color: "link",
      className: "otto__no_padding",
      onClick: () => context.openAuditLogModal(row.original.uuid)
    }, "Audit Log"),
    className: 'text-center',
    filterable: false,
    sortable: false,
    width,
    show,
    csvShow: false
  };
};
ColumnHelpers.editColumn = function (context) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    id: 'selection',
    Header: '',
    Cell: row => {
      const modalName = options.modalName || '';
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ColumnButton, {
        onClick: () => context.handleOpenModal(row.index, modalName),
        text: "edit"
      }), options.additional ? options.additional(row) : '');
    },
    className: 'text-center',
    filterable: false,
    sortable: false,
    csvShow: false,
    show: options.show || context.isEditAdmin(),
    width: options.width || 100
  };
};
ColumnHelpers.additonalButton = (text, onClick) => /*#__PURE__*/React.createElement("div", {
  style: {
    marginTop: '10px'
  }
}, /*#__PURE__*/React.createElement(ColumnButton, {
  text: text,
  onClick: onClick
}));
ColumnHelpers.columnEditButton = function (context) {
  let width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  let show = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : context.isEditAdmin();
  return {
    id: 'selection',
    Header: '',
    Cell: row => /*#__PURE__*/React.createElement(ColumnButton, {
      onClick: () => context.handleOpenModal(row.index),
      text: "edit"
    }),
    className: 'text-center',
    filterable: false,
    sortable: false,
    width,
    show,
    csvShow: false
  };
};
ColumnHelpers.activeInactiveColumn = function () {
  let width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  let show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return {
    id: 'active',
    Header: 'Active',
    accessor: 'active_inactive_text',
    filterMethod: (filter, row) => TableFilters.ActiveFilterMethod(filter, row),
    Filter: _ref => {
      let {
        filter,
        onChange
      } = _ref;
      return TableFilters.ActiveFilterOptions(filter, onChange);
    },
    Cell: row => HtmlHelpers.inactiveRed(row.original.active_inactive_text),
    className: 'text-center',
    width,
    show
  };
};
ColumnHelpers.activeColumn = function () {
  let width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  let show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return {
    id: 'active',
    Header: 'Active',
    accessor: 'active_text',
    className: 'text-center',
    width,
    show
  };
};
export default ColumnHelpers;